import { render, staticRenderFns } from "./PopupThemeChange.vue?vue&type=template&id=ffb11326"
import script from "./PopupThemeChange.vue?vue&type=script&lang=js"
export * from "./PopupThemeChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports